import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Problem", id: "problem" },
  { label: "Solution", id: "solution" },
  { label: "Trade Validation", id: "trade" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -64, duration: 1.3 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a1f33]/95 backdrop-blur-md border-b border-white/5"
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <button onClick={() => go("home")} className="relative flex items-center shrink-0" data-testid="nav-brand-logo">
          <img
            src="/verixx-logo.png"
            alt="VERIXX H2O — A LeakLock Company"
            className="h-9 w-auto drop-shadow-[0_0_12px_rgba(28,156,232,0.35)]"
          />
          <span className="absolute -top-0.5 -right-1.5 w-1.5 h-1.5 rounded-full bg-[#2aa7ec] animate-bead" />
        </button>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-[13px] font-medium text-slate-300 hover:text-white transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("contact")}
            className="hidden sm:flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1c9ce8] hover:bg-[#3ab0f5] text-white text-[13px] font-semibold transition-colors duration-300"
            data-testid="nav-pilot-cta-button"
          >
            Register Interest
            <ArrowRight className="w-4 h-4" />
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-slate-200 p-1"
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0a1f33] px-5 py-4 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-left py-2.5 text-sm font-medium text-slate-300 hover:text-white"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            className="mt-2 flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-[#1c9ce8] text-white text-sm font-semibold"
            data-testid="nav-mobile-register-button"
          >
            Register Interest
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </motion.header>
  );
}
